import { APP_LOCAL_KEYS } from "@/app/constants/constants";
import { typedLocalStorage } from "@/utils/storage/localStorage";

const SESSION_STORAGE_KEYS = [
  APP_LOCAL_KEYS.USER_DATA,
  APP_LOCAL_KEYS.USER_PERMISSIONS,
  APP_LOCAL_KEYS.TOKEN,
  APP_LOCAL_KEYS.CUSTOMER_ID,
  APP_LOCAL_KEYS.CUSTOMER_USER_ID,
  APP_LOCAL_KEYS.CUSTOMER_DATA,
  APP_LOCAL_KEYS.CUSTOMER_AUTH_USER,
  APP_LOCAL_KEYS.ADMIN_AS_CUSTOMER,
  APP_LOCAL_KEYS.IS_ADMIN_LOGIN_AS_CUSTOMER,
  APP_LOCAL_KEYS.WORKSPACE_DATA,
  APP_LOCAL_KEYS.WORKSPACE_ID,
  APP_LOCAL_KEYS.CUSTOMER_PORTAL_TOKEN,
  APP_LOCAL_KEYS.REDIRECT_PATH,
  APP_LOCAL_KEYS.COOKIE_SESSION,
] as const;

/**
 * Removes only application-owned auth, customer, and workspace session keys.
 *
 * @returns {void} Does not return a value. Clears stored app session data without touching unrelated storage.
 */
export const clearStoredSession = (): void => {
  SESSION_STORAGE_KEYS.forEach((storageKey) => {
    typedLocalStorage.removeItem(storageKey);
  });
};

/**
 * Clears application session data and preserves the current hostname subdomain.
 *
 * @returns {void} Does not return a value. Resets app session keys while keeping the active subdomain available.
 */
export const clearStoredSessionPreservingSubdomain = (): void => {
  const [hostnameSubdomain = ""] = window.location.hostname.split(".");

  clearStoredSession();
  typedLocalStorage.setItem(APP_LOCAL_KEYS.SUB_DOMAIN, hostnameSubdomain);
};
